module.exports = __webpack_public_path__ + "img/APP_banner.61da3a0f.jpg";